/**
 * HTTP header names used across tenant-scoped API calls.
 */
export const HTTP_HEADERS = {
  TENANT_NAME: 'x-tenant-name',
  AUTHORIZATION: 'Authorization',
} as const;
